export function getRawOffsetXFromEvent(event: DragEvent): number {
  const wrapperElement = event.currentTarget as HTMLElement;
  const rect = wrapperElement.getBoundingClientRect();
  return event.clientX - rect.left + wrapperElement.scrollLeft;
}
